import { sendChatMessage } from '../../services/api/chatApi';

/**
 * BroChat Agent API Service
 * Wraps the common chat API for brochat-specific handling
 */

export const broChatApi = {
  /**
   * Send message to BroChat agent
   * @param {string} message - Message text
   * @param {Array} images - Selected images
   * @param {Object} options - Options including conversationId, mode, etc
   * @returns {Promise<Object>} - Agent response
   */
  sendMessage: async (message, images = [], options = {}) => {
    try {
      const response = await sendChatMessage(message, images, options);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('[BroChat] API Error:', error);
      return {
        success: false,
        error: error.message || 'Failed to send message',
      };
    }
  },

  /**
   * Get chat history (placeholder for future implementation)
   */
  getHistory: async () => {
    // TODO: Implement history retrieval
    return [];
  },

  /**
   * Clear chat history (placeholder for future implementation)
   */
  clearHistory: async () => {
    // TODO: Implement history clearing
    return { success: true };
  },
};

export default broChatApi;
